import * as Types from 'src/actions/juridical-person/change-data/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';

export interface ChangeJuridicalPersonData extends Action {
  type: Types.CHANGE_JURIDICAL_PERSON_DATA;
  payload: JuridicalPersonData;
}

export type ChangeJuridicalPersonDataAction = ChangeJuridicalPersonData;

export const changeJuridicalPersonData: ActionCreator<ChangeJuridicalPersonData> =
  (juridicalPerson: JuridicalPersonData) => (
    {
      type: Types.CHANGE_JURIDICAL_PERSON_DATA,
      payload: juridicalPerson
    }
  );


// WEBPACK FOOTER //
// ./src/actions/juridical-person/change-data/ChangePhysicalPersonData.actions.tsx